import { useParams } from 'react-router-dom'
import { useDynamicPowerPricesEnabledContext } from 'src/Libs/dynamic-power-prices/context/dynamic-power-prices-enabled-provider'
import { useFirstThreeSixtySavingsEntry } from 'src/Libs/dynamic-power-prices/hooks/use-three-sixty-savings'
import { useTypedSelector } from 'src/State/RootReducer'

/**
 * A hook to determine the minimum "from" date for the cost savings chart
 */
const useCostSavingsChartMinFromDate = (): string | undefined => {
  const activeStorage = useTypedSelector(state => state.storage.activeStorage)
  const { storageId } = useParams<{ storageId: string }>()
  const { isDynamicPowerPriceEnabled, isDynamicPowerPriceEnabledForWallboxes, isDynamicPowerPriceEnabledForBattery } =
    useDynamicPowerPricesEnabledContext()
  const isDynamicPowerPriceEnabledForStorage =
    isDynamicPowerPriceEnabled || (isDynamicPowerPriceEnabledForWallboxes && isDynamicPowerPriceEnabledForBattery)

  const { firstSavingsDate } = useFirstThreeSixtySavingsEntry({
    storageId: storageId ?? activeStorage ?? '',
    isEnabled: isDynamicPowerPriceEnabledForStorage,
  })

  return firstSavingsDate
}

export default useCostSavingsChartMinFromDate
